module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/basic-product-f86b601bd4074f9a435fafd60a0568be.jpg";